import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
var Icon = function(props) {
    return /*#__PURE__*/ _jsxs("svg", _object_spread_props(_object_spread({
        viewBox: "0 0 24 24",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("g", {
                clipPath: "url(#clip0_5487_77539)",
                children: /*#__PURE__*/ _jsx("path", {
                    d: "M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM18.355 15.952V15.847C18.355 14.925 18.355 14.504 17.703 14.131C17.4934 14.0122 17.2782 13.9037 17.058 13.806C16.691 13.639 16.448 13.53 16.12 13.05C16.0808 12.993 16.0422 12.9357 16.004 12.878C15.659 12.353 15.41 11.975 14.462 12.125C12.597 12.421 12.459 12.749 12.377 13.303L12.364 13.394C12.243 14.204 12.221 14.476 12.559 14.831C13.824 16.158 14.582 17.115 14.812 17.675C14.924 17.948 15.212 18.775 15.014 19.593C16.2278 19.1095 17.3083 18.3425 18.165 17.356C18.275 16.982 18.355 16.516 18.355 15.952ZM12 3.833C9.683 3.833 7.59 4.799 6.104 6.349C6.281 6.472 6.435 6.645 6.541 6.883C6.745 7.34 6.745 7.811 6.745 8.228C6.745 8.556 6.745 8.868 6.85 9.093C6.994 9.401 7.616 9.533 8.165 9.647C8.362 9.689 8.564 9.731 8.748 9.782C9.254 9.922 9.646 10.377 9.959 10.742C10.089 10.893 10.282 11.116 10.379 11.172C10.429 11.136 10.59 10.961 10.669 10.674C10.731 10.454 10.713 10.26 10.624 10.154C10.064 9.494 10.095 8.224 10.268 7.755C10.54 7.016 11.39 7.071 12.012 7.111C12.244 7.126 12.462 7.141 12.626 7.12C13.248 7.042 13.44 6.095 13.575 5.91C13.867 5.51 14.761 4.907 15.315 4.535C14.2715 4.07099 13.142 3.83181 12 3.833Z",
                    fill: "#434B34"
                })
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_5487_77539",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "24",
                        height: "24",
                        fill: "white"
                    })
                })
            })
        ]
    }));
};
export default Icon;
